import AuthenticatedController from './AuthenticatedController';
import * as APIRoutes from '@mm/api-routes';
import NoteModel from '../model/NoteModel';

export type AddNoteResponse = {
  errors: any[];
  note: NoteModel;
  success: boolean;
};
export default class ContactsController extends AuthenticatedController {
  static async addNote(
    noteText: string,
    contactId: number,
  ): Promise<AddNoteResponse> {
    return super.post(`${APIRoutes.CONTACTS}/${contactId}/contact_notes`, {
      contactId,
      body: noteText,
    });
  }
}
